export type GlobalConfig = {
  AUTH_PROVIDER?: string
  SENTRY_ENVIRONMENT: 'dev' | 'stage' | 'prod'
  BACKEND_URL: string
  API_DOCS_URL?: string
  TENANT_API_DOCS_URL?: string
  AUTH0_CLIENT_ID?: string
  AUTH0_DOMAIN?: string
  AUTH0_AUDIENCE?: string
  KEYCLOAK_HOSTS?: string
  KEYCLOAK_REALM?: string
  KEYCLOAK_CLIENT_ID?: string
  IS_DEV_SERVER?: boolean
}

declare global {
  interface Window {
    __ENV__: GlobalConfig
  }
}

export const config: GlobalConfig = window.__ENV__
